import { RestaurantMenu } from "@/hooks/useMenu";
import { AppBar } from "@mui/material";
import { CategoryTabs } from "./CategoryTabs";
import { SearchBar } from "./SearchBar";
//import { LocationConfigurationContext } from "@/providers/LocationConfigurationProvider";
//import { useContext } from "react";
import { BusyDialogs } from "./BusyDialogs";

function Header({
  showCategoryTabs,
  showSearch = true,
  menu,
}: {
  showCategoryTabs: boolean;
  showSearch?: boolean;
  menu: RestaurantMenu;
}) {
  //const { dialogs } = useContext(LocationConfigurationContext);
  return (
    <AppBar
      position="sticky"
      className="!bg-background border-b !text-border md:border-none md:h-max"
      elevation={0}
    >
      <BusyDialogs
      /*dialogs={
          dialogs?.filter((dialog) => dialog.showOn.startsWith("busy-")) ?? []
        }*/
      />
      {showSearch && (
        <div className="flex w-full py-2 px-3 relative text-foreground">
          <SearchBar />
        </div>
      )}

      {showCategoryTabs && <CategoryTabs categories={menu?.categories ?? []} />}
    </AppBar>
  );
}

export { Header };
